import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-ExpandShape",
  "use": "svg-icon-ExpandShape-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-ExpandShape\"><path d=\"M10.129 3.173L12 5.071V0H7l1.865 1.892L6.727 3.97 1.871 8.827 0 6.929V12h5l-1.865-1.892L5.243 8z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol